import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DataStoreState } from '../../storage/data-store/data-store-state.type';

@Injectable({
    providedIn: 'root',
})
export class DataStoreApiService {
    private readonly http = inject(HttpClient);
    private readonly getUrl = `${environment.api.baseUrl}/api/client/datastore`; // EMHE replace with actual url

    getInitialData(): Observable<DataStoreState> {
        return this.http.get<DataStoreState>(this.getUrl);
    }


}
